import {z} from 'zod';

export const waitingListSchema = z.object({
    last_name: z.string().min(1, 'Le nom est obligatoire'),
    first_name: z.string().min(1, 'Le prénom est obligatoire'),
    email: z.string().email('Adresse mail incorrecte'),
    birth_date: z.string().min(1, 'La date de naissance est obligatoire'),
    socials: z.array(z.string().url('URL invalide').or(z.literal(''))).optional(),
    links: z.array(z.string().url('URL invalide').or(z.literal(''))).optional(),
    has_work: z.boolean().default(false),
    has_work_details: z.string().optional(),
    optin_tos: z.literal(true, {
        error: 'Vous devez accepter les conditions générales d’utilisation',
    }),
    optin_data_processing: z.literal(true, {
        error: 'Vous devez accepter le traitement de vos données',
    }),
    type: z.string().default('author'),
});

export type WaitingListForm = z.infer<typeof waitingListSchema>;
